import {connect} from 'react-redux';
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Button, Col, Icon, Row, Spin, Switch} from "antd";
import * as translations from "../../../constants/translations";
import * as formTypes from "../../../constants/formtypes";
import * as APP_CONFIG from "../../../constants/config";
const {benchmarkApi} = APP_CONFIG;

class LoggerEdit extends Component {

    static propTypes = {
        match: PropTypes.shape({
            params: PropTypes.shape({
                id: PropTypes.string.isRequired
            }).isRequired
        }).isRequired
    };

    state = {
        data: 'not loaded',
        saving: false
    };

    formFieldTypes = {
        "type": formTypes.TEXT,
        "panels": formTypes.NUMBER,
        "wp": formTypes.NUMBER,
        "active": formTypes.BOOLEAN
    };

    componentDidMount = async () => {
        await this.loadData(this.props.match.params.id);
    };

    componentWillReceiveProps = async (nextProps) => {
        if(this.props.match.params.id !== nextProps.match.params.id)
            await this.loadData(nextProps.match.params.id);
    };

    save = async () => {
        if(this.state.form.type && this.state.form.panels
           && this.state.form.wp) {
            const id = this.state.data.id;
            this.setState({saving: true});

            const request = await fetch(`${benchmarkApi}inverters/${id}` ,{
                method: 'POST',
                headers: {
                    'Content-type' : 'application/json'
                },
                body: JSON.stringify({...this.state.form, ...{id: id}})
            });
            const response = await request.json();
            console.log('save', response);

            this.setState({saving: false, data: 'reloading'});
            await this.loadData(id);
        }
    }

    loadData = async (id) => {
        const request = await fetch(`${benchmarkApi}inverters/${id}`);
        const data = await request.json();
        const form = {};
        Object.keys(data).forEach(key => {
            if(!this.formFieldTypes[key] || this.formFieldTypes[key] === formTypes.NONE)
                return;
            form[key] = data[key];
        })
        console.log(form)
        this.setState({data: data, form: form})
    };

    renderInput = (key) => {
        switch(this.formFieldTypes[key]){
            case formTypes.TEXT:
            case formTypes.EMAIL:
                return (
                    <input type={this.formFieldTypes[key]} value={this.state.form[key]} onChange={(event) => {
                        const form = {...this.state.form};
                        form[key] = event.target.value;
                        this.setState({form: form})
                    }} />
                )
            case formTypes.NUMBER:
                return (
                    <input type="number" min="0" step="1" value={this.state.form[key]} onChange={(event) => {
                        const form = {...this.state.form};
                        form[key] = event.target.value;
                        this.setState({form: form})
                    }} />
                )
            case formTypes.FLOAT:
                return (
                    <input type="number" min="0" value={this.state.form[key]} onChange={(event) => {
                        const form = {...this.state.form};
                        form[key] = event.target.value;
                        this.setState({form: form})
                    }} />
                )
            case formTypes.BOOLEAN:
                return (
                    <Switch checkedChildren={<Icon type="check" />} unCheckedChildren={<Icon type="close" />} checked={this.state.form[key]} value={this.state.form[key]} onChange={(val) => {
                        const form = {...this.state.form};
                        form[key] = val;
                        this.setState({form: form})
                    }} />
                )
            default:
                return (
                    <input type="text" value={this.state.form[key]} onChange={(event) => {
                        const form = {...this.state.form};
                        form[key] = event.target.value;
                        this.setState({form: form})
                    }} />
                )
        }
    }

    renderCol = (key, val) => {
        return <Row gutter={{xs: 0, md: 24}} className="dataview-row" key={key}>
            <Col xs={24} md={8} className="dataview-label">{translations.inverter[key] ? translations.inverter[key] : key}</Col>
            <Col xs={24} md={15} className="dataview-value">
                {
                    !this.formFieldTypes[key] || this.formFieldTypes[key] === formTypes.NONE ?
                         val : this.renderInput(key)
                }
            </Col>
        </Row>;
    }

    render() {
        const {data} = this.state;
        return (
            <div>

                {data.id ?
                    <div>
                        <h1>{data.name}</h1>
                        {Object.keys(data).filter(key => key !== "name").map((key) => this.renderCol(key, data[key]))}
                        <div>
                            <Button type={'primary'} onClick={this.save} loading={this.state.saving}>Opslaan</Button>
                        </div>
                    </div> : <Spin />}
            </div>
        );
    }
}

const mapStateToProps = (state) => {return {}};

export default connect(mapStateToProps)(LoggerEdit);



// WEBPACK FOOTER //
// ./src/components/baseinfo/loggers/edit.js